import React, {useCallback, useContext, useState, useEffect} from "react";
import  {config} from "../../../config";
//contexts
import MenuContext from "../../../contexts/Menu";
import TextsContext from "../../../contexts/Texts";
import SettingsContext from "../../../contexts/Settings";
import PlayerContext from "../../../contexts/Player";
import PageContext from "../../../contexts/Page";

//tools
import classnames from "classnames";

//svg components
import MenuClose from "../../svg/MenuClose";
import MenuOpen from "../../svg/MenuOpen";

//styles
import "./MenuTop.scss";
import Close from "../../svg/Close";

const MenuTop = () => {

	const {menu, menuOpened, setMenuOpened} = useContext(MenuContext);
	const {menu_glowne, social_media} = useContext(TextsContext);
	const {settingsData} = useContext(SettingsContext);
	const {video,setVideo} = useContext(PlayerContext);
	const {isHome} = useContext(PageContext);

	const [menuPosition, setMenuPosition] = useState(0);
	const [scrollLocked, setScrollLocked] = useState(false);

	const handleMenuTrigger = useCallback( () => {
		setMenuOpened(!menuOpened);
		setMenuPosition(window.scrollY);
	},[setMenuPosition,setMenuOpened,menuOpened])

	const handleMenuHash = useCallback((event, type, url) => {
			event.preventDefault();
			setMenuOpened(false);
			if (type === 'custom') {
				const el = document.getElementById(url.replace('#', ''));
				const posY = el.offsetTop;
				const posYoffset = window.innerWidth < 769 ? -141 : -100;
				window.scrollTo({
					top: posY + posYoffset,
					behavior: "smooth"
				});
				setScrollLocked( window.scrollY < menuPosition )

			} else {
				window.open(url, "_self")
			}
		}, [setMenuOpened,setScrollLocked,menuPosition]
	);

	const handleNavToHome = useCallback((event,type,url) => {
		event.preventDefault();
		const staticUrl = config.domain+config.domainRelPath+url;
		window.open(staticUrl, "_self");
		setTimeout(() => {
			handleMenuHash(event,type,url)
		}, 1000);

	},[setMenuOpened,setScrollLocked, menuPosition, config, handleMenuHash]);


	useEffect(() => {
		const handleScroll = () => {
			setScrollLocked( window.scrollY < menuPosition )
		};
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [menuPosition,setScrollLocked]);

	const menuStyle = {
		top: scrollLocked ? 0 : menuPosition,
		position: scrollLocked ? 'fixed' : 'absolute'
	}

	return (
		<>
			{!video ?
				<div className="menu-btn"
				     onClick={handleMenuTrigger}>
					{menuOpened ?
						<MenuClose mainColor={"#D0103A"}/> :
						<MenuOpen mainColor={"#D0103A"}/>
					}
				</div> :
				<button className="close-player" onClick={() => setVideo(null)}>
					<Close mainColor="#D0103A"/>
				</button>
			}


			<div
				className={classnames("menu-container", {
					"expanded": menuOpened
				})}
				style={menuStyle}
			>
				<div className={classnames( "menu-btn menu-btn__inner",{
						"close":menuOpened
					})}
				     onClick={handleMenuTrigger}>
					{menuOpened ?
						<MenuClose mainColor={"#2F2F30"}/> :
						<MenuOpen mainColor={"#D0103A"}/>
					}
				</div>
				<div className="menu-container-inner">
					<nav aria-label={menu_glowne} className="menu-top" >
						<ul>
							{
								menu?.filter(item => {
									return item.post_parent == 0 && item.menu_item_parent == 0;
								})
									.map(item =>
										<li
											key={item.url}
											data-id={item.object_id}
											className={item.ID === window.pageId ? "active" : ""}
										>
											<a
												href={isHome ? item.url : config.domain+config.domainRelPath+item.url}
												onClick={
													e =>
														isHome ?
															handleMenuHash(e, item.object, item.url) :
															handleNavToHome(e, item.object ,item.url)
											}
												aria-current={item.ID === window.pageId}
												title={`Link: ${item.title}`}
												target="_top">
												{item.title}
											</a>
											<ul>
												{
													menu?.filter(page => item.ID === parseInt(page.menu_item_parent))
														.map((page, index) =>
															<li
																key={page.object_id}
																data-id={item.object_id}>
																<a
																	href={isHome ? item.url : config.domain+config.domainRelPath+item.url}
																	onClick={e =>
																		isHome ?
																			handleMenuHash(e, item.object, item.url) :
																			handleNavToHome(e, item.object ,item.url)}
																	title={`Link: ${page.title}`}
																	aria-current={page.ID === window.pageId}
																	target="_top">
																	{page.title}
																</a>
															</li>
														)
												}
											</ul>
										</li>
									)}
						</ul>
					</nav>

					{
						settingsData?.social_media.length >0 &&
						<div className="menu-socialmedia-container">
							<header>{social_media}</header>
							<nav className="menu-socialmedia" >
								<ul>
									{settingsData?.social_media?.map( item => {
										const {social_etykieta,social_link} = item;
										return <li key={item.social_link}>
											<a href={social_link} target="_blank" rel="noopener noreferrer" title={`Link: ${social_etykieta}`}>
												{social_etykieta}
											</a>
										</li>
									})}
								</ul>
							</nav>
						</div>
					}


				</div>

			</div>
		</>
	);
};


export default MenuTop;